import React from "react";
import parse from "html-react-parser";
import styles from "./styles.module.sass";

interface ProductProps {
  intro?: string;
  imageUrl?: string;
  content?: string;
  title?: string;
  price?: string;
  inStock?: boolean;
  buyFromHotel?: boolean;
  buyLink?: string;
}

const Product: React.FC<ProductProps> = ({
  intro = "",
  imageUrl = "",
  content = "",
  title = "",
  price = "",
  inStock = false,
  buyFromHotel = false,
  buyLink = "",
}) => (
  <div className={styles.card}>
    <div className={styles.imageWrapper}>
      {imageUrl && <img src={imageUrl} alt={title} />}
      {content && (
        <div className={styles.cardContent}>
          {parse(content)}
        </div>
      )}
    </div>
    <div className={styles.productDetails}>
      <h2>{parse(title)}</h2>
      <p>
        {price} |{' '}
        {inStock ? (
          buyFromHotel ? (
            'Purchase from hotel'
          ) : (
            <a href={buyLink || 'https://www.theovecollection.com/shop'} target="_blank" rel="noopener noreferrer">
              Buy
            </a>
          )
        ) : (
          'Sold out'
        )}
      </p>
    </div>
  </div>
);

export default Product;
